var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPicsum = function SvgPicsum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#1A1A1A",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.5,28.6h-8.1l-1-7.1c-0.4-2.9-1.9-5.5-4.2-7.3c-2.3-1.8-5.2-2.5-8.1-2.1L12,19.5c-6,0.8-10.2,6.4-9.4,12.4l5,37     c0.8,5.5,5.5,9.5,10.9,9.5c0.5,0,1,0,1.5-0.1l2.1-0.3c0.5,5.6,5.2,10,10.9,10h53.6c6,0,11-4.9,11-11V39.6     C97.5,33.6,92.6,28.6,86.5,28.6z M91.5,39.6V71L75.7,52.9c-2.6-3-7.4-3-10,0L52.1,68.5l-4.9-5.4c-2.5-2.7-6.8-2.7-9.2,0L28,74     V39.6c0-2.7,2.2-5,5-5h53.6C89.3,34.6,91.5,36.9,91.5,39.6z M22,39.6v32.2l-2.8,0.4c-2.7,0.4-5.2-1.5-5.6-4.3L8.5,31     c-0.4-2.7,1.5-5.2,4.3-5.6l53.1-7.3c0.2,0,0.5,0,0.7,0c2.4,0,4.6,1.8,4.9,4.3l0.9,6.3H33C26.9,28.6,22,33.6,22,39.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 47.8,
    r: 6
  }))))));
};
export default SvgPicsum;